module.exports = __webpack_public_path__ + "media/assets/icons/bpmn_intermediate-event-catch-non-interrupting-timer-a3c6e202f3d9ab153562e064025a5099.svg";